import {
  FETCH_ATTENDANCE_FAIL,
  FETCH_ATTENDANCE_REQUEST,
  FETCH_ATTENDANCE_SUCCESS,
  SHOW_ATTENDANCE_FAIL,
  SHOW_ATTENDANCE_REQUEST,
  SHOW_ATTENDANCE_SUCCESS,
  UPDATE_ATTENDANCE_FAIL,
  UPDATE_ATTENDANCE_REQUEST,
  UPDATE_ATTENDANCE_SUCCESS,
} from "../../ActionType/UserType/AttendanceType";

export const getAttendanceReducer = (
  state = { loading: true, attendances: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_ATTENDANCE_REQUEST:
      return {
        loading: true,
      };
    case FETCH_ATTENDANCE_SUCCESS:
      return {
        loading: false,
        attendances: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_ATTENDANCE_FAIL:
      return {
        loading: false,
        total: 0,
        attendances: [],
        error: action.error,
      };
    default:
      return state;
  }
};
export const showAttendanceReducer = (
  state = { loading: true, attendances: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case SHOW_ATTENDANCE_REQUEST:
      return {
        loading: true,
      };
    case SHOW_ATTENDANCE_SUCCESS:
      return {
        loading: false,
        attendances: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case SHOW_ATTENDANCE_FAIL:
      return {
        loading: false,
        total: 0,
        attendances: [],
        error: action.error,
      };
    default:
      return state;
  }
};
export const updateAttendanceReducer = (
  state = { loading: false, attendances: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case UPDATE_ATTENDANCE_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_ATTENDANCE_SUCCESS:
      return {
        loading: false,
        attendances: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case UPDATE_ATTENDANCE_FAIL:
      return {
        loading: false,
        total: 0,
        attendances: [],
        error: action.error,
      };
    default:
      return state;
  }
};
